export default __webpack_public_path__ + "static/media/tz.bcd8f739.svg";